module.exports = __webpack_public_path__ + "img/EElephantArcher64_ua.223affc6.webp";